'use client';

import Skeleton from '@mui/material/Skeleton';
import type {CSSObject, Theme} from '@mui/material/styles';
import {headerOverlayProps} from '../header';

// Full-bleed masthead placeholder shared by the pages that open with a banner
// (home Hero, about BannerCard). Heights are passed in so each page matches
// its own real banner and the swap to the loaded image doesn't jump.
interface MastheadSkeletonProps {
  mobileHeight?: number | string;
  desktopHeight?: number | string;
  // Sizing for a banner whose height is not a plain pair of numbers (the hero's, which
  // is a viewport calculation); it replaces mobileHeight/desktopHeight when given.
  sizing?: (theme: Theme) => CSSObject;
  // Floats the header over the placeholder, matching a page whose hero does the same.
  headerOverlay?: boolean;
}

export function MastheadSkeleton({mobileHeight, desktopHeight, sizing, headerOverlay}: MastheadSkeletonProps) {
  return (
    <Skeleton
      variant="rectangular"
      animation="wave"
      sx={theme => ({
        width: '100%',
        height: mobileHeight,
        [theme.breakpoints.up('md')]: {height: desktopHeight},
        ...sizing?.(theme),
      })}
      {...(headerOverlay ? headerOverlayProps : {})}
    />
  );
}

MastheadSkeleton.displayName = 'MastheadSkeleton';
